import {
  Grid,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { createStyles, makeStyles } from "@material-ui/core";
import { ColumnModel, PageInfoModel } from "../../models/common.model";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { GetCollaborationStoresResponse } from "../../models/collaborationStores.model";
import {
  getTablePage,
  getTableSelectedRow,
} from "../../redux/table/tableSlice";
import InfoIcon from "@mui/icons-material/Info";
import FiberNewIcon from "@mui/icons-material/FiberNew";

const nextIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Next.png"
      alt=""
    />
  );
};
const previusIcon = () => {
  return (
    <img
      style={{ height: "12px", width: "10px" }}
      src="images/Previous.png"
      alt=""
    />
  );
};
const useStyles = makeStyles(() =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: "#CEE5D3 !important",
      },
    },
  }),
);
const columns: readonly ColumnModel[] = [
  { id: "companyName", label: "نام شرکت" },
  { id: "businessOwnerName", label: "نام صاحب کسب و کار" },
  { id: "nationalId", label: "شناسه ملی" },
  { id: "registrationNumber", label: "شماره ثبت" },
  { id: "phoneNumber", label: "شماره تلفن" },
  { id: "activityFieldTitle", label: "زمینه فعالیت" },
  { id: "personTypeTitle", label: "نوع شخص" },
];
interface Props {
  collaborationStoresList: GetCollaborationStoresResponse[];
  pageInfo: PageInfoModel;
  setCurrentPaginationInfo: (page: any) => void;
  currentPaginationInfo: any;
  handleRouteToCollaborationStoreDetail: Function;
}
const CollaborationStoreTable = ({
  currentPaginationInfo,
  pageInfo,
  collaborationStoresList,
  setCurrentPaginationInfo,
  handleRouteToCollaborationStoreDetail,
}: Props) => {
  const classes = useStyles();
  const history = useHistory<any>();

  const dispatch = useDispatch();
  const tableInfo = useSelector((state: any) => state.table);

  const changePageNumber = (newPageNumber: number) => {
    setCurrentPaginationInfo({
      pageNumber: newPageNumber,
      pageSize: 10,
    });
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    dispatch(
      getTableSelectedRow({
        selectedRowNum: 0,
      }),
    );
    dispatch(
      getTablePage({
        selectedPageNum: value,
      }),
    );
  };
  useEffect(() => {
    if (history.action === "POP") {
      setCurrentPaginationInfo({
        pageNumber: tableInfo.selectedPageNum,
        pageSize: 10,
      });
    }
  }, [history.action, setCurrentPaginationInfo, tableInfo.selectedPageNum]);
  console.log(collaborationStoresList, "uguuh");

  return (
    <div>
      <div>
        <div className="cardTableBorder">
          <TableContainer
            style={{ background: "#fff", maxHeight: "55vh" }}
            className="boxScroll"
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              style={{ borderCollapse: "collapse" }}
            >
              <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
                <TableRow
                  classes={{ root: classes.select }}
                  className={`${classes} borderRight borderLeft`}
                  selected={tableInfo.selectedRowNum}
                >
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight WidthRowNumber"
                    align="right"
                    style={{ width: "10vh", minWidth: "10vh" }}
                  >
                    ردیف
                  </TableCell>

                  {columns.map((column) => (
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight noWrap"
                      key={column.id}
                      align="right"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight noWrap"
                    sx={{ textAlign: "end !important" }}
                  >
                    <MoreHorizIcon
                      scale="scale(1.8) "
                      style={{ color: "#1D4A87" }}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <div style={{ width: "100%", height: "10px" }}></div>
              <TableBody>
                {collaborationStoresList
                  ? collaborationStoresList?.map((row, rowIndex) => {
                      return (
                        <TableRow
                          classes={{ root: classes.select }}
                          className={`${
                            rowIndex % 2 === 0 ? "rowTBodyE  " : "rowTBodyO "
                          } ${classes} borderRight borderLeft cursorPointer noWrap`}
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.key}
                          selected={tableInfo.selectedRowNum === rowIndex}
                          onClick={(e) => {
                            e.stopPropagation();
                            dispatch(
                              getTableSelectedRow({
                                selectedRowNum: rowIndex,
                              }),
                            );
                            handleRouteToCollaborationStoreDetail(row.key);
                          }}
                        >
                          <TableCell
                            className="textFont12 WidthRowNumber"
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell>
                          {columns.map((column) => {
                            const value =
                              row[
                                column.id as keyof GetCollaborationStoresResponse
                              ];
                            return (
                              <>
                                <TableCell
                                  className="textFont12"
                                  key={column.id}
                                  align="right"
                                >
                                  {!value ? (
                                    <>--</>
                                  ) : column.format && column.hasFormat ? (
                                    column.format(value)
                                  ) : (
                                    value?.toString()
                                  )}
                                </TableCell>
                              </>
                            );
                          })}
                          <TableCell
                            className="textFont12"
                            sx={{ textAlign: "end !important" }}
                          >
                            {row.isVisit === false && (
                              <FiberNewIcon
                                sx={{
                                  color: "#28A745",
                                  fontSize: "1.8rem",
                                  marginInline: "8px",
                                }}
                              />
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  : null}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div>
          <div className="row"></div>
          <Grid container xs={12}>
            <Grid item xs={4}>
              <span
                style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
              >
                تعداد کل :
                <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
              </span>
            </Grid>
            <Grid item xs={6} md={4}>
              <Pagination
                renderItem={(item) => (
                  <PaginationItem
                    components={{
                      previous: previusIcon,
                      next: nextIcon,
                    }}
                    {...item}
                  />
                )}
                sx={{
                  display: "flex",
                  justifyContent: "center !important",
                  direction: "ltr",
                  margin: "5px",
                  button: {
                    color: "#25D1C9",
                    fontSize: "14px !important",
                    fontFamily: "iranSans",
                  },
                }}
                count={
                  pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                }
                onChange={handleChangePagination}
                page={currentPaginationInfo.pageNumber}
              />
            </Grid>
            <Grid item xs={2} md={4}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default CollaborationStoreTable;
